import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default Leaflet icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});



const DEFAULT_LAT = 12.624066
const DEFAULT_LNG = 80.198693
const DEFAULT_ZOOM = 14;

const LocationMap = ({
    lat = DEFAULT_LAT,
    lng = DEFAULT_LNG,
    zoom = DEFAULT_ZOOM,
    markerLabel = "Radisson Blu Resort Temple Bay, Mamallapuram"
}) => {
    const openGoogleMaps = () => {
        const url = `https://www.google.com/maps?q=${lat},${lng}`;
        window.open(url, '_blank');
    };

    return (
        <div className="w-full h-96 rounded-xl overflow-hidden shadow-sm border border-gray-200 relative z-0">
            <MapContainer
                center={[lat, lng]}
                zoom={zoom}
                scrollWheelZoom={false}
                style={{ height: '100%', width: '100%' }}
            >
                {/* LAYER 1: Satellite Base */}
                <TileLayer
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                    attribution='Tiles &copy; Esri'
                />

                {/* LAYER 2: Transportation */}
                <TileLayer
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}"
                />

                {/* LAYER 3: Labels */}
                <TileLayer
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}"
                />

                <Marker position={[lat, lng]} eventHandlers={{ click: openGoogleMaps }}>
                    <Popup className="font-sans text-sm font-medium" closeButton={false}>
                        {markerLabel}
                        <br />
                        <button
                            onClick={openGoogleMaps}
                            className="text-blue-600 hover:underline"
                            type="button"
                        >
                            Open in Google Maps
                        </button>
                    </Popup>
                </Marker>
            </MapContainer>
        </div>
    );
};

export default LocationMap;
